// eslint-disable-next-line no-unused-vars
import {apiServicePostBuyTicket, apiServicePost} from "../services/api/api";
import {getUrlParam, capitalizeFirstLetter} from "../services/helpers/globals";

const state = () => ({
	statistics: {},
	//results: [],
	boughtTicketResponse: {},
	drawResultsPrinted: null,
	rebetResponse: null,
	combinations: 0,
	internalCombinations: 0,
	startingBetCombinations: 1,
	selectedBalls: [],
	slip: [],
	quickReplayDisabled: false
});

const mutations = {
	setResults(state, list) {
		state.results = list;
	},
	setSelectedBalls(state, list) {
		state.selectedBalls = list;
	},
	setInternalCombinations(state, list) {
		state.internalCombinations = list;
	},
	setMainCombinations(state, list) {
		state.combinations = list;
	},
	setStartingBetCombinations(state, list) {
		state.startingBetCombinations = list;
	},
	SOCKET_drawResultsPrinted(state, message) {
		state.drawResultsPrinted = message;
	},
	setSlip(state, message) {
		state.slip = message;
	},
	setQuickReplayDisabled(state, message) {
		state.quickReplayDisabled = message;
	},
	callBuyTicket(state, message) {
		state.boughtTicketResponse = message;
	},
	rebetResponse(state,message) {
		state.rebetResponse = message;
	},
	setGameStatistics(state, gameStatistics) {
		state.statistics = gameStatistics;
	}
};

const actions = {
	setSelectedBalls(context, data) {
		context.commit('setSelectedBalls', data);
	},
	setInternalCombinations(context, data) {
		context.commit('setInternalCombinations', data);
	},
	setSlip(context, data) {
		context.commit('setSlip', data);
	},
	setMainCombinations(context, data) {
		context.commit('setMainCombinations', data);
	},
	setStartingBetCombinations(context, data) {
		context.commit('setStartingBetCombinations', data);
	},
	setQuickReplayDisabled(context, data) {
		context.commit('setQuickReplayDisabled', data);
	},
	async callRebet(context,ticketId) {
		try {
			// BUY payload must be formdata - convert it
			var infoForm = new FormData();
			infoForm.append('SessionID', getUrlParam('token'));
			infoForm.append('Referer', 'https://localhost');
			infoForm.append('ticketId', ticketId);
			// ORI const data = await apiServicePost("luckyballs/ticket/buy",payload);
			const data = await apiServicePostBuyTicket("luckyballs/ticket/get/id", infoForm);
			context.commit('rebetResponse', data.data.TicketData.TicketData);
		} catch(error) {
			console.error("error fetching luckyballs/ticket/get/id", error);
		}
	},
	async callBuyTicket(context, payload) {
		try {
			// BUY payload must be formdata - convert it
			var infoForm = new FormData();
			// console.log('window[token] !!->>>>', getUrlParam('token'))
			infoForm.append('SessionID', getUrlParam('token'));
			// infoForm.append('Referer', 'http://localhost');
			for(let key in payload) {
				// console.log(key, ' PAYLOAD ->>>>', payload[key])
				if(key.includes("SelectedNumbers") || key.includes("selectedNumbers")) {
					payload[key].forEach((number) => {
						infoForm.append(`SelectedNumbers[]`, number);
					});
				} else {
					let capsFirstChar = capitalizeFirstLetter(key);
					infoForm.append(capsFirstChar, payload[key]);
				}
			}
			// ORI const data = await apiServicePost("luckyballs/ticket/buy",payload);
			const data = await apiServicePostBuyTicket("luckyballs/ticket/buy/terminal", infoForm);
			context.commit('callBuyTicket', data);
		} catch(error) {
			console.error("error fetching luckyballs/game-config/get", error);
		}
	},
	async getStatistics(context) {
		const {data} = await apiServicePost("luckyballs/statistics/get");
		if (data) {
			if ('Data' in data) {
				if ('BingoStats' in data.Data) {
					if (data.Data.BingoStats.length) {
						context.commit('setGameStatistics',data.Data.BingoStats[0])
					}
				}
			}
		}
	}
};

const getters = {
	allStatistics: state => state.statistics,
	//getResults: state => state.results,
	getBoughtTicketResp: state => state.boughtTicketResponse.data,
	drawResultsPrinted: state => state.drawResultsPrinted,
	getSelectedBalls: state => state.selectedBalls,
	getInternalCombinations: state => state.internalCombinations,
	getMainCombinations: state => state.combinations,
	getStartingBetCombinations: state => state.startingBetCombinations,
	getSlip: state => state.slip,
	getQuickReplayDisabled: state => state.quickReplayDisabled,
	getRebetResponse: state => state.rebetResponse
};

export default {
	state,
	mutations,
	getters,
	actions
};
